import useSeo from "@/lib/useSeo";
import PageHero from "@/components/site/PageHero";
import ServiceArea from "@/components/sections/ServiceArea";
import CtaBanner from "@/components/site/CtaBanner";

export default function Einsatzgebiet() {
    useSeo({
        title: "Einsatzgebiet – Reinigung in Innsbruck & ganz Tirol",
        description:
            "Wir reinigen in Innsbruck Stadt, Innsbruck-Land, Hall in Tirol, Telfs, Wattens, Schwaz, Wörgl, Kufstein, Seefeld und Imst – auf Anfrage auch im erweiterten Tiroler Raum.",
        path: "/einsatzgebiet",
    });
    return (
        <div>
            <PageHero
                eyebrow="Einsatzgebiet"
                title="Reinigung in Innsbruck und ganz Tirol"
                lead="Vom Treppenhaus in einer Wohnanlage bis zur Glasfassade eines Bürogebäudes – wir bringen die Erfahrung und das Equipment, um Ihr Objekt sichtbar besser zu machen."
                breadcrumbs={[{ label: "Einsatzgebiet" }]}
            />
            <ServiceArea />
            <CtaBanner />
        </div>
    );
}
